import React from "react";
import { cn } from "../../utils/styles";

interface TooltipProps {
  text: string;
  type?: "primary" | "nav";
  position?: "left" | "top" | "top-right";
  additionalComponent?: React.ReactNode;
  destructive?: boolean;
}

export const ToolTip = ({
  text,
  additionalComponent,
  type,
  destructive,
  position = "left",
}: TooltipProps) => {
  if (type === "nav") {
    return (
      <div
        className={cn(
          "flex items-center justify-center absolute z-[99] pointer-events-none",
          position === "top" && "flex-col-reverse -top-14 left-1/2 transform -translate-x-1/2",
          position === "left" && "top-0 left-14",
          position === "top-right" && "flex-col-reverse -top-14 right-0",
        )}>
        <div
          className={cn(
            "bg-black z-[51]",
            destructive && "bg-red-500",
            position === "left" && "clip-left mt-2 h-[12px] w-[6px]",
            position === "top" && "clip-down w-[12px] h-[6px]",
            position === "top-right" && "clip-down w-[12px] h-[6px] mr-10 self-end",
          )}></div>
        <div
          className={cn(
            "mt-2 text-white bg-black text-sm px-3 py-2 rounded-[2px] w-fit",
            destructive && "bg-red-500",
          )}>
          <p className="text-[16px] leading-[20.16px] text-nowrap">{text}</p>
          {additionalComponent}
        </div>
      </div>
    );
  }

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      className="bg-ghost-100 absolute top-full right-0 mt-2 text-black text-sm px-3 py-2 rounded-md border-ominimo-400 border-[1px] shadow-md w-[200px]">
      <p className="text-blue-750 font-medium text-[13px] leading-[18.2px] tracking-[0.25px] decoration-transparent decoration-1">
        {text}
      </p>
      {additionalComponent}
    </div>
  );
};
